export class Configuration {
    static server: string = '';

    static async loadConfig(): Promise<void> {
        const response = await fetch('/assets/settings.json');
        const data = await response.json();
        Configuration.server = data.apiUrl; 
    }
    //static server = 'http://10.1.100.147:5000'; //TOKIC
    //static server = 'http://localhost:44336'; //LOCAL RAZVOJ
    //static server = 'http://localhost:5000'; //DS RAZVOJ
   // static server = 'http://192.168.12.219:5078'; //PRODUCTION
}